import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ToastContainer } from '../Shared/Kit/Toast';
import routePaths from './NameSpace';
import Index from '../Pages/Index';
import Investments from '../Pages/Investments';
import InvestmentDetails from '../Pages/Investments/InvestmentDetails';
import Notifications from '../Pages/Notifications';
import Announcements from '../Pages/Announcements';

const RoutesComponent = () => {
  const theme = useSelector((state) => state.App.theme);

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route
            path={routePaths.default}
            element={<Announcements />}
          />
          {/* <Route
            path={routePaths.default}
            element={<Index />}
          /> */}
          <Route
            path={routePaths.index}
            element={<Index />}
          />
          <Route
            path={routePaths.investments}
            element={<Investments />}
          />
          <Route
            path={routePaths.investmentDetails}
            element={<InvestmentDetails />}
          />
          <Route
            path={routePaths.announcements}
            element={<Announcements />}
          />
          <Route
            path={routePaths.notifications}
            element={<Notifications />}
          />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </ThemeProvider>
  );
};

export default RoutesComponent;